<template>
  <v-card class="payment-review-modal">
    <v-card-title class="payment-review-modal__heading">Please, check all information again and confirm</v-card-title>
    <v-container
      class="pt-0"
      fluid
      grid-list-lg
    >
      <v-layout
        class="row--data"
        row
      >
        <v-flex xs4>
          <v-subheader class="v-subheader--dense font-weight-medium black--text">Payment</v-subheader>
        </v-flex>
        <v-flex xs8>
          <div
            id="review-transaction-type"
            class="font-weight-medium"
          >{{ transactionType }}</div>
        </v-flex>
      </v-layout>
      <slot />

      <data-divider />

      <v-layout
        class="row--data"
        row
      >
        <v-flex xs4>
          <v-subheader class="v-subheader--dense font-weight-medium black--text">Payment amount</v-subheader>
        </v-flex>
        <v-flex xs8>
          <div
            id="review-amount"
            class="font-weight-medium"
          >{{ formData.amount | number }} {{ formData.currency }}</div>
        </v-flex>
      </v-layout>

      <template v-if="isFeeDetailsVisible">
        <v-layout
          v-if="formData.automaticFee"
          class="row--data"
          row
        >
          <v-flex xs4>
            <v-subheader class="v-subheader--dense">Account Nr. for fee</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div id="review-fee-account">{{ formData.feeAccount }}</div>
          </v-flex>
        </v-layout>

        <v-layout
          class="row--data"
          row
        >
          <v-flex xs4>
            <v-subheader class="v-subheader--dense">Fee</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div id="review-fee">{{ feeAmount | number }} {{ formData.feeCurrency }}</div>
          </v-flex>
        </v-layout>
      </template>

      <v-layout
        v-if="hasSettlementDate"
        class="row--data"
        row
      >
        <v-flex xs4>
          <v-subheader class="v-subheader--dense">Settlement date</v-subheader>
        </v-flex>
        <v-flex xs8>
          <div id="review-settlement-date">{{ formData.settlementDate | date }}</div>
        </v-flex>
      </v-layout>

      <data-divider />

      <v-layout
        class="row--data"
        row
      >
        <v-flex xs4>
          <v-subheader class="v-subheader--dense">Comment to the transfer</v-subheader>
        </v-flex>
        <v-flex xs8>
          <div id="review-comment">{{ formData.comment }}</div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-divider class="grey lighten-3" />

    <v-card-actions class="payment-review-modal__actions">
      <v-btn
        id="review-confirm"
        color="primary"
        flat="flat"
        :disabled="confirmed"
        @click="confirm"
      >Confirm</v-btn>

      <v-btn
        id="review-cancel"
        color="primary"
        flat="flat"
        @click="closeModal"
      >Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapActions } from 'vuex'

  // Events
  import { EVENT_PAYMENT_REVIEW_CONFIRM } from '@/events/payments'

  // Components
  import DataDivider from '@/components/payments/ReviewModal/DataDivider'

  export default {
    name: 'PaymentReviewModal',
    components: {
      DataDivider
    },
    props: {
      formData: {
        required: true,
        type: Object
      },
      transactionType: {
        required: true,
        type: String
      },
      feeAmount: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        confirmed: false
      }
    },
    computed: {
      isFiscalTypeFee () {
        return this.formData.feeType != null
      },
      isFeeDetailsVisible () {
        return !this.formData.unidentifiedRecipient && !this.isFiscalTypeFee
      },
      hasSettlementDate () {
        return this.formData.settlementDate != null && this.formData.settlementDate !== ''
      }
    },
    methods: {
      ...mapActions('modal', ['closeModal']),
      confirm () {
        this.confirmed = true
        this.$eventHub.$emit(EVENT_PAYMENT_REVIEW_CONFIRM)
      }
    }
  }
</script>

<style lang="scss">
  .payment-review-modal {
    font-size: 16px;
    font-weight: 400;

    &__heading,
    .container {
      padding-right: 30px;
      padding-left: 30px;
    }

    &__heading {
      font-size: 24px;
      font-weight: 400;
      line-height: 32px;
      padding-top: 21px;
    }

    &__actions {
      padding: 14px 14px;
    }
  }
</style>
